import React from 'react'

import DatetimePicker from '../forms/datetime-picker'

import moment from 'moment'

import {
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

export default React.createClass({
  getInitialState () {
    return {
      startsAtDirty: false,
      endsAtDirty: false
    }
  },

  onStartsAtChange (value) {
    const endsAtMoment = moment(this.props.endsAt.value)

    let newEndValue = endsAtMoment

    if (!this.state.endsAtDirty) {
      newEndValue = value.clone().add(9, 'hours')
      this.props.endsAt.onChange(value, newEndValue)
    } else if (!endsAtMoment.isValid() || endsAtMoment.isSameOrBefore(value)) {
      newEndValue = value.clone().add(5, 'minutes')
      this.props.endsAt.onChange(value, newEndValue)
    }

    this.setState({ startsAtDirty: true })
    this.props.startsAt.onChange(value, newEndValue)
  },

  onEndsAtChange (value) {
    const startsAtMoment = moment(this.props.startsAt.value)

    let newStartValue = startsAtMoment

    if (!this.state.startsAtDirty) {
      newStartValue = value.clone().subtract(9, 'hours')
      this.props.startsAt.onChange(newStartValue, value)
    } else if (!startsAtMoment.isValid() || startsAtMoment.isSameOrAfter(value)) {
      newStartValue = value.clone().subtract(5, 'minutes')
      this.props.startsAt.onChange(newStartValue, value)
    }

    this.setState({ endsAtDirty: true })
    this.props.endsAt.onChange(newStartValue, value)
  },

  render () {
    const {
      startsAt,
      endsAt
    } = this.props

    return (
      <div className='group'>
        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='startsAt'>starts</label>
            <DatetimePicker {...startsAt} onChange={this.onStartsAtChange} />
          </ModalFormBlock>
        </ModalFormRow>
        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='startTime'>ends</label>
            <DatetimePicker {...endsAt} onChange={this.onEndsAtChange} />
          </ModalFormBlock>
        </ModalFormRow>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/work-orders/work-order-time-fields.js